// import logo from './logo.svg';
import './App.css';

import Dashboard from "./components/dashboard";
import Login from './components/login'
// import TableHeader from './components/nav'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';       
// import Spreadsheet from './components/handsontable';
function App() {
  return (
    
    <Routes>
      <Route path="/" element={<Login/>} />
      <Route path="/dashboard" element={<Dashboard />} />
    </Routes>

  );
}

export default App;
